import CryptoJS from 'crypto-js'

import api from '@/api'
import { KEY_ME, KEY_REFRESH_TOKEN, KEY_TOKEN } from '@/fixtures/Constants'
import { CRYPTO_KEY } from '@/fixtures/Hash'

const encryptedRefreshTokenKey = btoa(KEY_REFRESH_TOKEN)
const encryptedTokenKey = btoa(KEY_TOKEN)
const encryptedMeKey = btoa(KEY_ME)

const namespaced = true

const state = () => ({
  isAuthenticated: !!localStorage.getItem(encryptedTokenKey),
  me: localStorage.getItem(encryptedMeKey) || null,
  token: localStorage.getItem(encryptedTokenKey) || null,
  refreshToken: localStorage.getItem(encryptedRefreshTokenKey) || null
})

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  me: state => state.me
    ? JSON.parse(CryptoJS.AES.decrypt(state.me, CRYPTO_KEY).toString(CryptoJS.enc.Utf8))
    : null,
  token: state => state.token
    ? CryptoJS.AES.decrypt(state.token, CRYPTO_KEY).toString(CryptoJS.enc.Utf8)
    : null,
  refreshToken: state => state.refreshToken
    ? CryptoJS.AES.decrypt(state.refreshToken, CRYPTO_KEY).toString(CryptoJS.enc.Utf8)
    : null
}

const mutations = {
  SET_ME: (state, payload) => {
    state.me = payload
    localStorage.setItem(encryptedMeKey, payload)
  },
  SET_TOKEN: (state, payload) => {
    state.token = payload
    state.isAuthenticated = true
    localStorage.setItem(encryptedTokenKey, payload)
  },
  SET_REFRESH_TOKEN: (state, payload) => {
    state.refreshToken = payload
    localStorage.setItem(encryptedRefreshTokenKey, payload)
  }
}

const actions = {
  async login({ commit, dispatch }, payload) {
    try {
      const { data } = await api.login(payload)
      commit('SET_TOKEN', CryptoJS.AES.encrypt(data.token, CRYPTO_KEY).toString())
      commit('SET_REFRESH_TOKEN', CryptoJS.AES.encrypt(data.refreshToken, CRYPTO_KEY).toString())

      await dispatch('fetchMe')
    } catch (err) {
      throw err.data || err.message
    }
  },
  async loginViaCookies({ commit, dispatch }, payload) {
    try {
      commit('SET_TOKEN', CryptoJS.AES.encrypt(payload.token, CRYPTO_KEY).toString())
      commit('SET_REFRESH_TOKEN', CryptoJS.AES.encrypt(payload.refreshToken, CRYPTO_KEY).toString())

      await dispatch('fetchMe')
    } catch (err) {
      throw err.data || err.message
    }
  },
  async fetchMe({ commit }) {
    try {
      const { data } = await api.getMe()
      commit('SET_ME', CryptoJS.AES.encrypt(JSON.stringify(data), CRYPTO_KEY).toString())
    } catch (err) {
      throw err.data || err.message
    }
  },
  async logout({ dispatch }) {
    try {
      await api.logout()
      await dispatch('reset')
    } catch (err) {
      throw err.data || err.message
    }
  },
  reset({ state }) {
    localStorage.removeItem(encryptedRefreshTokenKey)
    localStorage.removeItem(encryptedTokenKey)
    localStorage.removeItem(encryptedMeKey)
    state.isAuthenticated = false
  }
}

export default { namespaced, state, getters, mutations, actions }
